import api from '../../api'

import {
    CREATE_NEW_BECPRICE,
    DELETE_BECPRICE,
    GET_BECPRICE,
    RESET_BECPRICE,
    SET_BECPRICE,
    SET_BECPRICE_ID,
    SET_BECPRICE_DATE_CREATED,
    SET_BECPRICE_DATE_MODIFIED,
    SET_BECPRICE_DIRTYNESS,
    SET_BECPRICE_PARENT_PATH,
    SET_BECPRICE_PATH,
    UPDATE_BECPRICE,
    SET_BECPRICE_NUMBER,
    SET_BECPRICE_QUARTER,
    SET_BECPRICE_YEAR,
    SET_BECPRICE_AIRE_ACONDICIONADO,
    SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA,
    SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES,
    SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES,
    SET_BECPRICE_ALBANILERIA_AZOTEAS,
    SET_BECPRICE_ALBANILERIA_GRUESA,
    SET_BECPRICE_ALBANILERIA_SOLADOS,
    SET_BECPRICE_ASCENSORES,
    SET_BECPRICE_CALEFACCION,
    SET_BECPRICE_CARPINTERIA_EXTERIOR,
    SET_BECPRICE_CARPINTERIA_INTERIOR,
    SET_BECPRICE_CERRAJERIA,
    SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO,
    SET_BECPRICE_ELECTRICIDAD,
    SET_BECPRICE_ENERGIA_SOLAR_ACS,
    SET_BECPRICE_ESTRUCTURA,
    SET_BECPRICE_FONTANERIA,
    SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA,
    SET_BECPRICE_INSTAL_ESPECIALES,
    SET_BECPRICE_JARDINERIA_DECORATIVA,
    SET_BECPRICE_MAT_SANITARIO_GRIFERIA,
    SET_BECPRICE_MOVIMIENTO_TIERRAS,
    SET_BECPRICE_PERSIANAS,
    SET_BECPRICE_PINTURA_Y_ESTUCOS,
    SET_BECPRICE_RENOVACION_AIRE,
    SET_BECPRICE_SANEAMIENTO,
    SET_BECPRICE_SEGURIDAD_Y_SALUD,
    SET_BECPRICE_SUBTOTAL,
    SET_BECPRICE_TOTAL,
    SET_BECPRICE_VIDRIERIA,
    SET_BECPRICE_YESERIA_CIELOSRASOS,

} from '../../constants'

const default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    number: null,
    quarter: null,
    year: null,
    aire_acondicionado: null,
    albanileria_acabados_fachada: null,
    albanileria_acabados_interiores: null,
    albanileria_ayudas_industriales: null,
    albanileria_azoteas: null,
    albanileria_gruesa: null,
    albanileria_solados: null,
    ascensores: null,
    calefaccion: null,
    carpinteria_exterior: null,
    carpinteria_interior: null,
    cerrajeria: null,
    cimentacion_y_muro_sotano: null,
    electricidad: null,
    energia_solar_acs: null,
    estructura: null,
    fontaneria: null,
    fumisteria_y_muebles_cocina: null,
    instal_especiales: null,
    jardineria_decorativa: null,
    mat_sanitario_griferia: null,
    movimiento_tierras: null,
    persianas: null,
    pintura_y_estucos: null,
    renovacion_aire: null,
    saneamiento: null,
    seguridad_y_salud: null,
    subtotal: null,
    total: null,
    vidrieria: null,
    yeseria_cielosrasos: null,

}

const state = default_state

const actions = {

    CREATE_NEW_BECPRICE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.create({key: data.key, path: data.path})
                .then((res) => {
                    const new_created_key = res.key

                    commit(SET_BECPRICE_ID, res.key)
                    commit(SET_BECPRICE_DATE_CREATED, res.date_created)
                    commit(SET_BECPRICE_DATE_MODIFIED, res.date_modified)
                    commit(SET_BECPRICE_PATH, res.path)
                    commit(SET_BECPRICE_PARENT_PATH, data.parent_path)

                    api.set_value({
                        value: res.key,
                        path: data.path + new_created_key + '/' + 'id',
                        save_timestamp: false
                        }).then((res) => resolve({key: new_created_key}))
                    })
                })

    },
    DELETE_BECPRICE: ({state, commit, rootState}, data) => {

        // console.log('DELETE_BECPRICE path check: ' + data.path)
        // console.log('DELETE BECPRICE parent_path check: ' + data.parent_path)

        // delete from becprices/becprice_key
        api.delete({key: data.key, path: data.path})
            .then((res) => {


            })

    },
    GET_BECPRICE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            return api.get({path: data.path})
                .then(res => resolve(res))
        })

    },
    SET_BECPRICE: ({state, commit, rootState}, data) => {

        // console.log('set_becprice data:')
        // console.log(data)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_BECPRICE, res)
            })

    },
    RESET_BECPRICE: ({state, commit, rootState}) => {
        commit(RESET_BECPRICE)
    },
    SET_BECPRICE_REPORTDATE: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_REPORTDATE, data)
    },
    SET_BECPRICE_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_DATE_CREATED, data)
    },
    SET_BECPRICE_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_DATE_MODIFIED, data)
    },

    SET_BECPRICE_ID: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ID, data)
    },
    SET_BECPRICE_PARENT_PATH: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_PARENT_PATH, data)
    },
    SET_BECPRICE_PATH: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_PATH, data)
    },
    UPDATE_BECPRICE: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            // console.log('UPDATE_BECPRICE data:')
            // console.log(data)
            api.update({object: data.object, path: data.path + data.key, save_timestamp: true})
                .then((res) => {

                    const date_modified = res.date_modified
                    commit(SET_BECPRICE_DATE_MODIFIED, res.date_modified)
                    commit(SET_BECPRICE_DIRTYNESS, false)
                    resolve()

                })
        })
    },
    SET_BECPRICE_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_NUMBER, data)
    },
    SET_BECPRICE_QUARTER: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_QUARTER, data)
    },
    SET_BECPRICE_YEAR: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_YEAR, data)
    },
    SET_BECPRICE_AIRE_ACONDICIONADO: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_AIRE_ACONDICIONADO, data)
    },
    SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA, data)
    },
    SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES, data)
    },
    SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES, data)
    },
    SET_BECPRICE_ALBANILERIA_AZOTEAS: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ALBANILERIA_AZOTEAS, data)
    },
    SET_BECPRICE_ALBANILERIA_GRUESA: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ALBANILERIA_GRUESA, data)
    },
    SET_BECPRICE_ALBANILERIA_SOLADOS: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ALBANILERIA_SOLADOS, data)
    },
    SET_BECPRICE_ASCENSORES: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ASCENSORES, data)
    },
    SET_BECPRICE_CALEFACCION: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_CALEFACCION, data)
    },
    SET_BECPRICE_CARPINTERIA_EXTERIOR: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_CARPINTERIA_EXTERIOR, data)
    },
    SET_BECPRICE_CARPINTERIA_INTERIOR: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_CARPINTERIA_INTERIOR, data)
    },
    SET_BECPRICE_CERRAJERIA: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_CERRAJERIA, data)
    },
    SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO, data)
    },
    SET_BECPRICE_ELECTRICIDAD: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ELECTRICIDAD, data)
    },
    SET_BECPRICE_ENERGIA_SOLAR_ACS: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ENERGIA_SOLAR_ACS, data)
    },
    SET_BECPRICE_ESTRUCTURA: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_ESTRUCTURA, data)
    },
    SET_BECPRICE_FONTANERIA: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_FONTANERIA, data)
    },
    SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA, data)
    },
    SET_BECPRICE_INSTAL_ESPECIALES: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_INSTAL_ESPECIALES, data)
    },
    SET_BECPRICE_JARDINERIA_DECORATIVA: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_JARDINERIA_DECORATIVA, data)
    },
    SET_BECPRICE_MAT_SANITARIO_GRIFERIA: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_MAT_SANITARIO_GRIFERIA, data)
    },
    SET_BECPRICE_MOVIMIENTO_TIERRAS: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_MOVIMIENTO_TIERRAS, data)
    },
    SET_BECPRICE_PERSIANAS: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_PERSIANAS, data)
    },
    SET_BECPRICE_PINTURA_Y_ESTUCOS: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_PINTURA_Y_ESTUCOS, data)
    },
    SET_BECPRICE_RENOVACION_AIRE: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_RENOVACION_AIRE, data)
    },
    SET_BECPRICE_SANEAMIENTO: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_SANEAMIENTO, data)
    },
    SET_BECPRICE_SEGURIDAD_Y_SALUD: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_SEGURIDAD_Y_SALUD, data)
    },
    SET_BECPRICE_SUBTOTAL: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_SUBTOTAL, data)
    },
    SET_BECPRICE_TOTAL: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_TOTAL, data)
    },
    SET_BECPRICE_VIDRIERIA: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_VIDRIERIA, data)
    },
    SET_BECPRICE_YESERIA_CIELOSRASOS: ({state, commit, rootState}, data) => {
        commit(SET_BECPRICE_YESERIA_CIELOSRASOS, data)
    },
}

const mutations = {

    [RESET_BECPRICE] (state) {
        state.date_created = null
        state.date_modified = null
        state.dirty = false
        state.file_id = null
        state.id = null
        state.path = null
        state.parent_path = null
        state.number = null
        state.quarter = null
        state.year = null
        state.aire_acondicionado = null
        state.albanileria_acabados_fachada = null
        state.albanileria_acabados_interiores = null
        state.albanileria_ayudas_industriales = null
        state.albanileria_azoteas = null
        state.albanileria_gruesa = null
        state.albanileria_solados = null
        state.ascensores = null
        state.calefaccion = null
        state.carpinteria_exterior = null
        state.carpinteria_interior = null
        state.cerrajeria = null
        state.cimentacion_y_muro_sotano = null
        state.electricidad = null
        state.energia_solar_acs = null
        state.estructura = null
        state.fontaneria = null
        state.fumisteria_y_muebles_cocina = null
        state.instal_especiales = null
        state.jardineria_decorativa = null
        state.mat_sanitario_griferia = null
        state.movimiento_tierras = null
        state.persianas = null
        state.pintura_y_estucos = null
        state.renovacion_aire = null
        state.saneamiento = null
        state.seguridad_y_salud = null
        state.subtotal = null
        state.total = null
        state.vidrieria = null
        state.yeseria_cielosrasos = null
    },
    [SET_BECPRICE] (state, data) {
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.dirty = false
        state.file_id = check_undefined(data.file_id)
        state.id = check_undefined(data.id)
        state.path = check_undefined(data.path)
        state.parent_path = check_undefined(data.parent_path)
        state.number = check_undefined(data.number)
        state.quarter = check_undefined(data.quarter)
        state.year = check_undefined(data.year)
        state.aire_acondicionado = check_undefined(data.aire_acondicionado)
        state.albanileria_acabados_fachada = check_undefined(data.albanileria_acabados_fachada)
        state.albanileria_acabados_interiores = check_undefined(data.albanileria_acabados_interiores)
        state.albanileria_ayudas_industriales = check_undefined(data.albanileria_ayudas_industriales)
        state.albanileria_azoteas = check_undefined(data.albanileria_azoteas)
        state.albanileria_gruesa = check_undefined(data.albanileria_gruesa)
        state.albanileria_solados = check_undefined(data.albanileria_solados)
        state.ascensores = check_undefined(data.ascensores)
        state.calefaccion = check_undefined(data.calefaccion)
        state.carpinteria_exterior = check_undefined(data.carpinteria_exterior)
        state.carpinteria_interior = check_undefined(data.carpinteria_interior)
        state.cerrajeria = check_undefined(data.cerrajeria)
        state.cimentacion_y_muro_sotano = check_undefined(data.cimentacion_y_muro_sotano)
        state.electricidad = check_undefined(data.electricidad)
        state.energia_solar_acs = check_undefined(data.energia_solar_acs)
        state.estructura = check_undefined(data.estructura)
        state.fontaneria = check_undefined(data.fontaneria)
        state.fumisteria_y_muebles_cocina = check_undefined(data.fumisteria_y_muebles_cocina)
        state.instal_especiales = check_undefined(data.instal_especiales)
        state.jardineria_decorativa = check_undefined(data.jardineria_decorativa)
        state.mat_sanitario_griferia = check_undefined(data.mat_sanitario_griferia)
        state.movimiento_tierras = check_undefined(data.movimiento_tierras)
        state.persianas = check_undefined(data.persianas)
        state.pintura_y_estucos = check_undefined(data.pintura_y_estucos)
        state.renovacion_aire = check_undefined(data.renovacion_aire)
        state.saneamiento = check_undefined(data.saneamiento)
        state.seguridad_y_salud = check_undefined(data.seguridad_y_salud)
        state.subtotal = check_undefined(data.subtotal)
        state.total = check_undefined(data.total)
        state.vidrieria = check_undefined(data.vidrieria)
        state.yeseria_cielosrasos = check_undefined(data.yeseria_cielosrasos)
    },
    [SET_BECPRICE_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_BECPRICE_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_BECPRICE_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_BECPRICE_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_BECPRICE_PARENT_PATH] (state, data) {
        state.parent_path = data
        state.dirty = true
    },
    [SET_BECPRICE_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_BECPRICE_NUMBER] (state, data) {
        state.number = data
        state.dirty = true
    },
    [SET_BECPRICE_QUARTER] (state, data) {
        state.quarter = data
        state.dirty = true
    },
    [SET_BECPRICE_YEAR] (state, data) {
        state.year = data
        state.dirty = true
    },
    [SET_BECPRICE_AIRE_ACONDICIONADO] (state, data) {
        state.aire_acondicionado = data
        state.dirty = true
    },
    [SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA] (state, data) {
        state.albanileria_acabados_fachada = data
        state.dirty = true
    },
    [SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES] (state, data) {
        state.albanileria_acabados_interiores = data
        state.dirty = true
    },
    [SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES] (state, data) {
        state.albanileria_ayudas_industriales = data
        state.dirty = true
    },
    [SET_BECPRICE_ALBANILERIA_AZOTEAS] (state, data) {
        state.albanileria_azoteas = data
        state.dirty = true
    },
    [SET_BECPRICE_ALBANILERIA_GRUESA] (state, data) {
        state.albanileria_gruesa = data
        state.dirty = true
    },
    [SET_BECPRICE_ALBANILERIA_SOLADOS] (state, data) {
        state.albanileria_solados = data
        state.dirty = true
    },
    [SET_BECPRICE_ASCENSORES] (state, data) {
        state.ascensores = data
        state.dirty = true
    },
    [SET_BECPRICE_CALEFACCION] (state, data) {
        state.calefaccion = data
        state.dirty = true
    },
    [SET_BECPRICE_CARPINTERIA_EXTERIOR] (state, data) {
        state.carpinteria_exterior = data
        state.dirty = true
    },
    [SET_BECPRICE_CARPINTERIA_INTERIOR] (state, data) {
        state.carpinteria_interior = data
        state.dirty = true
    },
    [SET_BECPRICE_CERRAJERIA] (state, data) {
        state.cerrajeria = data
        state.dirty = true
    },
    [SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO] (state, data) {
        state.cimentacion_y_muro_sotano = data
        state.dirty = true
    },
    [SET_BECPRICE_ELECTRICIDAD] (state, data) {
        state.electricidad = data
        state.dirty = true
    },
    [SET_BECPRICE_ENERGIA_SOLAR_ACS] (state, data) {
        state.energia_solar_acs = data
        state.dirty = true
    },
    [SET_BECPRICE_ESTRUCTURA] (state, data) {
        state.estructura = data
        state.dirty = true
    },
    [SET_BECPRICE_FONTANERIA] (state, data) {
        state.fontaneria = data
        state.dirty = true
    },
    [SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA] (state, data) {
        state.fumisteria_y_muebles_cocina = data
        state.dirty = true
    },
    [SET_BECPRICE_INSTAL_ESPECIALES] (state, data) {
        state.instal_especiales = data
        state.dirty = true
    },
    [SET_BECPRICE_JARDINERIA_DECORATIVA] (state, data) {
        state.jardineria_decorativa = data
        state.dirty = true
    },
    [SET_BECPRICE_MAT_SANITARIO_GRIFERIA] (state, data) {
        state.mat_sanitario_griferia = data
        state.dirty = true
    },
    [SET_BECPRICE_MOVIMIENTO_TIERRAS] (state, data) {
        state.movimiento_tierras = data
        state.dirty = true
    },
    [SET_BECPRICE_PERSIANAS] (state, data) {
        state.persianas = data
        state.dirty = true
    },
    [SET_BECPRICE_PINTURA_Y_ESTUCOS] (state, data) {
        state.pintura_y_estucos = data
        state.dirty = true
    },
    [SET_BECPRICE_RENOVACION_AIRE] (state, data) {
        state.renovacion_aire = data
        state.dirty = true
    },
    [SET_BECPRICE_SANEAMIENTO] (state, data) {
        state.saneamiento = data
        state.dirty = true
    },
    [SET_BECPRICE_SEGURIDAD_Y_SALUD] (state, data) {
        state.seguridad_y_salud = data
        state.dirty = true
    },
    [SET_BECPRICE_SUBTOTAL] (state, data) {
        state.subtotal = data
        state.dirty = true
    },
    [SET_BECPRICE_TOTAL] (state, data) {
        state.total = data
        state.dirty = true
    },
    [SET_BECPRICE_VIDRIERIA] (state, data) {
        state.vidrieria = data
        state.dirty = true
    },
    [SET_BECPRICE_YESERIA_CIELOSRASOS] (state, data) {
        state.yeseria_cielosrasos = data
        state.dirty = true
    },
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

const getters = {
    becprice: state => {
        return state
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/becprice/becprice.js